import React from 'react';
import { cn } from '@/lib/utils';

export const SectionNavItem = ({
  index,
  isSelected,
  handleSelectionChanged,
  title,
  ...props
}) => (
  <div
    {...props}
    role="tab"
    tabIndex={0}
    className={cn(
      'min-w-0 flex-1 cursor-pointer text-center text-sm font-medium leading-[56px] transition-colors sm:text-base',
      'first:rounded-l-[30px] last:rounded-r-[30px]',
      isSelected
        ? 'bg-primary text-primary-foreground shadow-inner'
        : 'bg-white/50 text-primary hover:bg-primary/10',
    )}
    onClick={() => handleSelectionChanged(index)}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleSelectionChanged(index);
      }
    }}
  >
    {title}
  </div>
);
